/**
 * @generated SignedSource<<00b7b8e44642e9b61b4f40df106eef94>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type GlobalSideNavigation$data = {
  readonly userSideNavSettings: {
    readonly sidebar: {
      readonly nodes: ReadonlyArray<{
        readonly menuId: string | null | undefined;
        readonly visible: boolean | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "GlobalSideNavigation";
};
export type GlobalSideNavigation$key = {
  readonly " $data"?: GlobalSideNavigation$data;
  readonly " $fragmentSpreads": FragmentRefs<"GlobalSideNavigation">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "entityAriUserSideNavSettings"
    },
    {
      "kind": "RootArgument",
      "name": "ownerAri"
    }
  ],
  "kind": "Fragment",
  "name": "GlobalSideNavigation",
  "selections": [
    {
      "alias": "userSideNavSettings",
      "args": [
        {
          "kind": "Variable",
          "name": "entityAri",
          "variableName": "entityAriUserSideNavSettings"
        },
        {
          "kind": "Variable",
          "name": "ownerAri",
          "variableName": "ownerAri"
        }
      ],
      "concreteType": "SettingsNavigationCustomisation",
      "kind": "LinkedField",
      "name": "settings_navigationCustomisation",
      "plural": false,
      "selections": [
        {
          "concreteType": "SettingsMenuItemConnection",
          "kind": "LinkedField",
          "name": "sidebar",
          "plural": false,
          "selections": [
            {
              "concreteType": "SettingsMenuItem",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "menuId"
                },
                {
                  "kind": "ScalarField",
                  "name": "visible"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "92d3bcd16841187fcf53685a6966300d";

export default node;
